import React, {Component} from 'react'
import {Form,Col,Row,Alert,Radio} from 'antd';
import {setCardBooking,getCards} from '../../../actions/paymentActions'
import {connect} from 'react-redux';
import ProtoType from 'prop-types'
import SplitFormStripe from "../../Settings/Dashboard/Include/SplitFormStripe";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

class SelectCard extends Component {

    constructor(props) {
        super(props)

        this.state = {
            user: {},
            loading:false,
            setCardDefault:true,
            error:[],
            disableSubmit:true,
        }
    }

    onChangeCardBooking = (e)=>{

        let card_id = e.target.value || ''
        if(card_id != ''){
           this.props.setCardBooking(this.props.cards.filter(card=>card._id == card_id).pop())
        }

    }

    render() {
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        }
        return (

            <Row>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>

                    {this.props.cards.length == 0  && ( <Alert message="You have not added any cards yet. " type="info"/> )}

                    {this.props.cards.length > 0 && (


                        <div>
                            <Radio.Group onChange={this.onChangeCardBooking} value={this.props.cardBooking._id}>
                                {this.props.cards.map(card=> {
                                    return  (<Radio disabled={card.brainTreeCardToken} key={card._id} style={radioStyle} value={card._id}>
                                        {/************* {card.lastFourDigits} - ({ card.cardType}) */}
                                        <span className="brand" style={{marginRight: 10, fontWeight: 600}}>{card.cardType}</span>
                                        <span className="number"><span>**** **** ****</span> {card.lastFourDigits} __ <span style={{fontWeight: 600}}>{card.brainTreeCardToken ? 'Braintree' : 'Stripe'}</span></span>
                                    </Radio>)
                                })}
                            </Radio.Group>
                        </div>

                    )}
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <Elements stripe={stripePromise} options={{locale : 'en' }}>
                        <SplitFormStripe getCards={this.props.getCards} />
                    </Elements>
                </Col>
            </Row>
        )
    }
}


SelectCard.protoType = {
    cards:ProtoType.array.isRequired,
    cardBooking:ProtoType.object.isRequired,
}

const mapStateToProps = (state)=> {
    return {
    }
}
const WrappedSelectCard = Form.create()(SelectCard);
export default connect(mapStateToProps, {setCardBooking,getCards})(WrappedSelectCard)



// WEBPACK FOOTER //
// ./src/components/Booking/Include/SelectCard.js